import React from "react"
import { Typography, styled } from "@mui/material"

type Props = React.HTMLAttributes<HTMLHeadingElement> & {
  children: React.ReactNode
}

const TitleComponent = ({ children, ...restProps }: Props) => {
  return (
    <Title variant="h1" {...restProps}>
      {children}
    </Title>
  )
}

export default TitleComponent

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "1.75rem",
  lineHeight: "34px",
  fontWeight: "600",
  marginBottom: "41px",
  [theme.breakpoints.down("md")]: {
    fontSize: "1.375rem",
    margin: "10px 0 20px 0",
  },
}))
